/* eslint-disable no-unused-vars */
// reactstrap components
import { Card, CardHeader, CardBody, CardTitle, Row, Col } from "reactstrap";

import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  postAcao,
  getAllAbas,
  updateTab,
} from "redux/actions/Screening/screeningActions";
import logo from "logo.svg";
import { getUser } from "./../authetication/adal-config";
import _ from "lodash";
import moment from "moment";
import "moment/locale/pt-br";
import api from "services/api";
import LiveTranscriptModal from "views/modals/live-transcript";

let header = {
  Authorization: "bearer " + localStorage.getItem("teste"),
};
moment.locale("pt-br");

const options = [
  { name: "Econômico", icon: "nc-icon nc-chart-pie-36" },
  { name: "Macro", icon: "nc-icon nc-globe" },
  { name: "Bolsa", icon: "nc-icon nc-bank" },
  { name: "MARB", icon: "nc-icon nc-app" },
  { name: "Crédito", icon: "nc-icon nc-app" },
  { name: "Quant", icon: "nc-icon nc-chart-bar-32" },
  { name: "Controle", icon: "nc-icon nc-badge" },
  { name: "Comercial", icon: "nc-icon nc-credit-card" },
  { name: "Infra", icon: "nc-icon nc-credit-card" },
];

function Perfil(props) {
  getUser();
  //getGroups();
  const [hover, setHover] = useState({
    Econômico: false,
    Macro: false,
    Bolsa: false,
    Controle: false,
    Comercial: false,
  });

  const [openTranscript, setOpenTranscript] = useState(false);
  const toggleTranscript = () => setOpenTranscript(!openTranscript);

  const groupBy = (lista, coluna1) => {
    var colunas = {};
    var resultado = [];

    lista.forEach(function (item) {
      var reg = {};
      colunas[item[coluna1]] = colunas[item[coluna1]] || [];

      for (var i in item) reg[i] = item[i];

      colunas[item[coluna1]].push(reg);
    });

    for (var i in colunas) resultado.push({ key: i, values: colunas[i] });
    resultado = resultado.map((item) => {
      item.key = Number(item.key);
      return item;
    });
    resultado = resultado.map(({ values }) => {
      return _.sortBy(values, function (dateObj) {
        return Number(dateObj.ordem);
      });
    });
    // resultado.sort(function (a, b) {
    //   var keyA = Number(a.ordem),
    //     keyB = Number(b.ordem);
    //   if (keyA < keyB) return -1;
    //   if (keyA > keyB) return 1;
    //   return 0;
    // });

    // resultado.forEach((x) => {
    //   x.values.sort(function (a, b) {
    //     var keyA = a.titulo,
    //       keyB = b.titulo;
    //     if (keyA < keyB) return -1;
    //     if (keyA > keyB) return 1;
    //     return 0;
    //   });
    // });
    //console.log(resultado);
    return resultado;
  };

  function delay(time) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }

  const saveAbas = async (abas) => {
    for (let aba of abas) {
      let model = {
        params: {
          arg1: aba.area,
          arg2: aba.menu,
          arg3: aba.titulo,
          arg4: aba.largura,
          arg5: aba.altura,
          arg6: aba.titulo,
          arg7: aba.tipoAba,
          arg8: aba.ordem,
        },
      };
      api.post("updateCard", header, model, function (status, data) {});
      await delay(2000);
      //props.updateTab(model);
      //console.log(model);
    }
  };

  // useEffect(() => {
  //   props.getAllAbas();
  // }, []);

  // useEffect(() => {
  //   if (props.allTabs.length > 0) {
  //     let newDataGroup = [];
  //     let dataGroup = groupBy(props.allTabs, "idMenu");
  //     //console.log(dataGroup);
  //     for (let item of dataGroup) {
  //       if (item.some((v) => Number(v.ordem) > 50)) {
  //         let id = 1;
  //         let newItem = item.map((news) => {
  //           news.ordem = id;
  //           id = id + 1;
  //           return news;
  //         });
  //         newDataGroup.push(newItem);
  //       }
  //     }
  //     console.log(newDataGroup)
  //     // let teste = _.sampleSize(newDataGroup,30)
  //     for(let dat of newDataGroup){
  //       saveAbas(dat);
  //     }
  //     //console.log(newDataGroup);
  //   }
  // }, [props.allTabs]);

  useEffect(() => {
    const delayFunction = async () => {
      let user = JSON.parse(localStorage.getItem("user-profile"));
      let model = {
        usuario: user?.username,
        acao: `Acesso a tela inicial`,
        pagina_origem: "home",
      };
      postAcao(model);

      let url = sessionStorage.getItem(
        "msal.7bb136bb-3896-4f7a-a52c-8ba9cf56b536.request.origin"
      );
      let code = window.location.hash;
      if (url?.includes("admin") && code && code.includes("code")) {
        let area = localStorage.getItem("area");
        let menu = localStorage.getItem("menu");
        let model = {
          usuario: user?.username,
          acao: `O menu ${localStorage.getItem(
            "menu_completo"
          )} da área ${area} foi selecionado`,
          pagina_origem: `Home`,
        };
        postAcao(model);

        await delay(1000);

        window.location.href = url;
      }
    };

    delayFunction();
  }, []);

  const changeArea = (area) => {
    let user = JSON.parse(localStorage.getItem("user-profile"));
    let model = {
      usuario: user?.username,
      acao: `Área ${area} foi selecionada na tela inicial`,
      pagina_origem: "home",
    };
    postAcao(model);
    localStorage.setItem("area", area);
    setTimeout(function () {
      props.history.push(`/admin/${area}/dashboard`);
    }, 700);
  };

  const mouseLeave = (area) => {
    setHover({ [area]: false });
  };

  const mouseHouver = (area) => {
    setHover({ [area]: true });
  };

  return (
    <div
      className="content"
      style={{
        backgroundRepeat: "no-repeat",
        backgroundImage:
          "url(https://devlnxstorage.blob.core.windows.net/storage/background.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center center",
        minHeight: "100vh",
      }}
    >
      <div style={{ margin: "0 20px", padding: "20px" }}>
        <div style={{ padding: 20 }}>
          <img height="40px" src={logo} alt="react-logo" />
        </div>

        <Row style={{ justifyContent: "center" }}>
          {options.map((item, index) => (
            <Col key={index} md={4}>
              <Card
                style={
                  hover[item.name]
                    ? {
                        backgroundColor: "#d3cccc",
                        textAlign: "center",
                        cursor: "pointer",
                        marginBottom: "20px",
                      }
                    : {
                        textAlign: "center",
                        cursor: "pointer",
                        marginBottom: "20px",
                      }
                }
                onMouseEnter={() => {
                  mouseHouver(item.name);
                }}
                onMouseLeave={() => {
                  mouseLeave(item.name);
                }}
                onClick={(e) => changeArea(item.name)}
              >
                <CardHeader>
                  <CardTitle tag="h5">{item.name}</CardTitle>
                </CardHeader>
                <CardBody>
                  <div>{item.Descricao}</div>
                </CardBody>
              </Card>
            </Col>
          ))}
          {/* <Col md={4}>
            <Card
              onClick={toggleTranscript}
              style={{
                textAlign: "center",
                cursor: "pointer",
                marginBottom: "20px",
              }}
            >
              <CardHeader>
                <CardTitle tag="h5">Live Transcript</CardTitle>
              </CardHeader>
              <CardBody>
                <div></div>
              </CardBody>
            </Card>
          </Col> */}
        </Row>
      </div>
      <LiveTranscriptModal isOpen={openTranscript} toggle={toggleTranscript} />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    allTabs: state.screening.screening.allTabs,
    data: state.screening.screening.data,
    error: state.screening.screening.error,
  };
};

export default connect(mapStateToProps, { getAllAbas, updateTab })(Perfil);
